/**
 * Date helpers shared by the calendar grid + compose modal (M1.14 wave 3).
 *
 * `withTenAM` defaults the time when the user clicks a blank calendar day
 * (10am local — sensible default for a business comms tool). The local-input
 * pair converts between `Date` and the value format expected by
 * <input type="datetime-local">.
 */

export function withTenAM(d: Date): Date {
  const x = new Date(d);
  x.setHours(10, 0, 0, 0);
  return x;
}

export function toLocalInputValue(d: Date): string {
  const pad = (n: number): string => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInputValue(s: string): string {
  return new Date(s).toISOString();
}
